import type { Beneficiary } from "@/app/types/beneficiaries";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";


interface BeneficiaryEditState {
  beneficiary: Beneficiary | null;
}

const initialState: BeneficiaryEditState = {
  beneficiary: null,
};

const beneficiaryEditSlice = createSlice({
  name: "beneficiaryEdit",
  initialState,
  reducers: {
    setBeneficiary: (state, action: PayloadAction<Beneficiary>) => {
      state.beneficiary = action.payload;
    },
    clearBeneficiary: (state) => {
      state.beneficiary = null;
    },
  },
});

export const { setBeneficiary, clearBeneficiary } = beneficiaryEditSlice.actions;
export default beneficiaryEditSlice.reducer;
